<script>
  import { page } from '$app/stores';
  import { ReviewForm, imgSrc, Pagination, Link, store } from '$client';
  export let data;

  const { city } = store;
  $: reviewPage = data.reviewPage;
  $: reviews = data.reviews;
  $: topics = reviewPage.form.data.attributes.fields.reduce(
    (acc, v) => (v.key === 'topic' && (acc = v), acc),
    undefined,
  ).options;
  const defaultImg = {
    url: 'https://admin.uberi.pro/uploads/review_photo_8d44aad77c.svg',
    alt: 'Изображение клиента',
  };
  const removeCity = url => url.replace(/^\/gorod-[a-z0-9-_]+\/?/, '/');
  $: active = topic => (topic === $page.url.searchParams.get('topic') ? { class: 'active-route', disabled: true } : {});
</script>

<section id="main">
  <div id="reviews" class="container">
    <div itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating">
      <meta
        itemprop="ratingValue"
        content={Math.max(3.8, reviews.data.reduce((acc, v) => acc + v.attributes.rating, 0) / data.length)} />
      <meta itemprop="reviewCount" content={reviews.data.length * reviews.meta.pagination.pageCount} />
      <div itemprop="itemReviewed" itemscope itemtype="https://schema.org/ProfessionalService">
        <meta itemprop="name" content="Вывоз ненужных вещей в г. {$city.header}" />
        <meta itemprop="image" content="/favicon.svg" />
        <meta itemprop="telephone" content={$city.phone} />
        <meta itemprop="address" content={$city.office} />
      </div>
    </div>
    <h1>{reviewPage.header}</h1>
    <nav class="margin-block">
      <Link attributes={active(null)} href={$page.url.origin + $page.url.pathname}>Все отзывы</Link>
      {#each topics as topic}
        <Link
          attributes={active(topic.header)}
          href={removeCity($page.url.pathname) + '?topic=' + encodeURI(topic.header)}>{topic.header}</Link>
      {/each}
    </nav>
    <ul>
      {#each reviews.data as review}
        <li class="review" itemprop="review" itemscope itemtype="http://schema.org/Review">
          <meta itemprop="name" value="Отзыв нашего клиента" />
          <div>
            <img
              itemprop="image"
              src={imgSrc((review.attributes.img.data?.attributes ?? defaultImg).url)}
              alt={(review.attributes.img.data?.attributes ?? defaultImg).alternativeText} />
            <div>
              <h2 itemprop="author" itemscope itemtype="https://schema.org/Person">
                <span itemprop="name"> {review.attributes.name}</span>
              </h2>
              <div itemprop="itemReviewed" itemscope itemtype="https://schema.org/ProfessionalService">
                <meta itemprop="name" content="Вывоз ненужных вещей в г. {$city.header}" />
                <meta itemprop="image" content="/favicon.svg" />
                <meta itemprop="telephone" content={$city.phone} />
                <meta itemprop="address" content={$city.office} />
              </div>
              <div itemprop="reviewRating" itemscope itemtype="http://schema.org/Rating">
                <meta itemprop="worstRating" content="0" />
                <meta itemprop="bestRating" content="5" />
                <meta itemprop="ratingValue" content={review.attributes.rating} />
                {#each new Array(5).fill() as _, i}
                  <span data-selected={review.attributes.rating > i} />
                {/each}
              </div>
            </div>
          </div>
          <blockquote itemprop="reviewBody">{review.attributes.review}</blockquote>
        </li>
      {/each}
    </ul>
    <Pagination pages={reviews.meta.pagination.pageCount} />
  </div>
  <ReviewForm data={reviewPage.form.data.attributes} />
</section>

<style lang="scss">
  h1 {
    color: #2c333c;
    font-weight: 800;
    font-size: 48px;
    font-family: Vela Sans;
    font-style: normal;
    line-height: 130%; /* 62.4px */
    letter-spacing: 0.48px;
  }

  nav {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 20px;
    max-width: 100%;
    overflow: auto;

    @media only screen and (max-width: 575.98px) {
      flex-wrap: nowrap;
      gap: 10px;

      :global(a),
      :global(div) {
        white-space: nowrap;
      }
    }

    :global(.active-route) {
      color: #fff;
      background: #2c333c;
    }

    :global(a),
    :global(div) {
      padding: 8px 24px;
      color: #2c333c;
      font-weight: 500;
      font-size: 16px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 140%; /* 22.4px */
      background: #f6f7f8;
      border-radius: 100px;

      &:hover {
        color: #fff;
        background: #2c333c;
      }
    }
  }

  blockquote {
    position: relative;
    display: -webkit-box;
    width: 100%;
    overflow: hidden;
    color: #2c333cd9;
    font-size: 16px;
    font-family: Roboto;
    line-height: 140%;
    white-space: normal;
    text-overflow: ellipsis;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }

  span {
    width: 24px;
    height: 24px;
    background-position: center center;
    background-size: contain;
    cursor: pointer;
  }

  span[data-selected='true'] {
    background-image: url('https://admin.uberi.pro/uploads/star_7137f7de2b.svg');
  }

  span[data-selected='false'] {
    background-image: url('https://admin.uberi.pro/uploads/star_3e7a6d378e.svg');
  }

  .review {
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
    padding: 20px;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 1px 15px 0 rgb(0 15 92 / 5%);

    h2 {
      color: #2c333c;
      font-weight: bold;
      font-size: 16px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 130%; /* 20.8px */
    }

    > div {
      display: inline-flex;
      gap: 20px;
      align-items: center;
      width: 100%;

      > div {
        display: flex;
        flex-direction: column;
        gap: 5px;

        > div {
          display: inline-flex;
          gap: 8px;
        }
      }
    }
  }

  #reviews > ul {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 40px;

    @media only screen and (max-width: 991.98px) {
      grid-template-columns: 1fr 1fr;
      gap: 30px;
    }

    @media only screen and (max-width: 767.98px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }

  #main {
    display: flex;
    flex-direction: column;
    gap: 80px;
    margin-block: 50px;

    @media only screen and (max-width: 767.98px) {
      gap: 50px;
      margin-block: 30px;
    }
  }
</style>
